import { Grid, Card, Box, Typography } from "@mui/material";
import { organizationPrimaryColors } from "../../../../layouts/PermanentSidebarMUI";
import { useOrgan } from "../../../../hooks/useOrgan";

const ShipmentsDetailsSection = ({ section, children }) => {
  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  return (
    <Grid item xs={12}>
      <Card sx={{ backgroundColor: "#ffffffff", p: 2 }}>
        <Box key={section} sx={{ mb: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              backgroundColor: primaryColor,
              py: 1,
              px: 3,
              color: "#ffffff",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
              mb: 2,
              mt: -2,
              mr: -2,
              ml: -2,
            }}>
            {section}
          </Typography>

          {children}
        </Box>
      </Card>
    </Grid>
  );
};

export default ShipmentsDetailsSection;
